import config from '../config'
import client from './client'

const endpoint = 'admin/alttext/'

const generateCoverAlt = (body) => {
  return client.post(config.serverUrl + endpoint + 'cover-image', body)
}

export default {
  generateCoverAlt,
}
